import React, { Fragment } from 'react';
import { BreadcrumbComponent, BackLink, Item, ItemActive } from './mixins';
export const Breadcrumb = (props) => {
    const { links = [], currentTitle, onBackLinkClick } = props;
    return (React.createElement(BreadcrumbComponent, Object.assign({}, props),
        onBackLinkClick && React.createElement(BackLink, { onClick: onBackLinkClick }, "Volver"),
        links.map(({ title, link }, index) => {
            const isNotLastItem = index < links.length - 1;
            const showCaret = isNotLastItem || currentTitle;
            return (React.createElement(Fragment, { key: title },
                showCaret && (React.createElement(Item, { href: link, icon: {
                        name: 'icon-light-caret-right',
                        position: 'right',
                        color: 'primary',
                    }, linkoptions: {
                        native: false,
                        size: 'small',
                        type: 'link',
                        variant: 'primary',
                    } }, title)),
                !showCaret && (React.createElement(ItemActive, { disabled: true, linkoptions: { native: false, size: 'small', type: 'link', variant: 'black' } }, title))));
        }),
        currentTitle && React.createElement(ItemActive, null, currentTitle)));
};
